module.exports = __webpack_public_path__ + "img/bg.3ef9f9f8.jpg";